export const ideasRoutes = {
  default:'agency_ideas'
}
